module.exports = __webpack_public_path__ + "img/Yousef.a6ce8af9.webp";